
    import './styles.scoped.css';
    export default {
  "button-dropdown": "awsui_button-dropdown_sne0l_1r35l_5",
  "items-list-container": "awsui_items-list-container_sne0l_1r35l_9",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_sne0l_1r35l_1",
  "rotate-up": "awsui_rotate-up_sne0l_1r35l_26",
  "rotate-down": "awsui_rotate-down_sne0l_1r35l_41",
  "header": "awsui_header_sne0l_1r35l_56",
  "title": "awsui_title_sne0l_1r35l_65",
  "description": "awsui_description_sne0l_1r35l_66"
};
  